import { setupWorker, graphql, rest } from 'msw';

import * as appSyncHandlers from './appSync';

declare global {
    interface Window {
        msw: {
            worker: import('msw').SetupWorkerApi;
            graphql: unknown;
            rest: unknown;
        };
    }
}

/**
 * A mock service worker that only handles AppSync requests ; it does not handle Cognito requests.
 */
export const appSyncWorker = setupWorker(...Object.values(appSyncHandlers));

// Expose methods globally to make them available in e2e tests
window.msw = {
    worker: appSyncWorker,
    graphql,
    rest,
};
